<script>
  import pedidosServico from '../servico.js';

  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import ListaItens from './compartilhado/FormListaItens.vue';
  import projetoServico from '~modulos/projeto/servico';
  import ModalLiberarPedido from '~componentes/ModalLiberarPedido.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  

  export default {
    components: { Cabecalho, ListaItens, ModalLiberarPedido, ModalMensagem, ModalArquivosSolicitacao },
    data() {
      return {
        pedido: {},
        pedidoSelecionado: null,
        modalLiberarPedido: false,
        salvandoLiberacao: false,
        carregando: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
        numeroProcesso: '',       
        solicitacaoSelecionada: null,
        modalMensagem: false,
        modalArquivos: false,
      }
    },
    methods: {
      carregar: function (id) {
        this.carregando = true;

        pedidosServico
          .obterPorIdRelatorio(id)
          .then(pedido => {
            this.carregando = false;
            this.pedido = pedido;
            this.orgaoFinanciador;
          })
          .catch(erro => {
            this.carregando = false;

            if (erro.status === 422) { 
              this.$swal('', erro.body.message, 'error');
            } else{
              this.$swal('', 'Ocorreu um erro ao exibir relatório de pedido, tente novamente.', 'error');
            }

            this.$router.push('/pedido');
          });
      },
      mostrarModalLiberarPedido(pedido) {
        this.pedidoSelecionado = pedido;
        this.modalLiberarPedido = true;
      },
      modalLiberarPedidoFechado() {
        this.animated = false;
        this.modalLiberarPedido = false;
        this.pedidoSelecionado = null;
      },
      liberar() {
        $('#liberar').button('loading');
        this.modalLiberarPedido = false;

        return pedidosServico
          .liberar(this.$route.params.id)
          .then(() => {
            $('#liberar').button('reset');

            toastr.success(`Pedido de compra liberado com sucesso.`);
            $('body').removeClass('modal-open');

            this.$router.push({ name: 'liberar-pedidos-compra' });
          })
          .catch(erro => {
            $('#liberar').button('reset');

            this.$mensagemErro(erro, 'Erro ao tentar liberar o pedido de compra.');
          });
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },   
    },
    computed: {
      periodoDeVigencia() {
        let dataInicio = this.pedido.projeto.dataInicioVigencia;
        let dataTermino = this.pedido.projeto.dataTerminoVigencia;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      periodoProjeto() {
        let dataInicio = this.pedido.projeto.dataInicio;
        let dataTermino = this.pedido.projeto.dataTermino;

        if (dataInicio === 0 && dataTermino === 0) {
          return '---';
        }

        let periodo = this.$options.filters.formatarNumeroEmData(dataInicio);

        if (dataTermino) {
          periodo += ` - ${this.$options.filters.formatarNumeroEmData(dataTermino)}`;
        }

        return periodo;
      },
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmData(this.solicitacao.liberacaoCoordenador) || '---';
      },
      enderecoPedido() {
        let auxEndereco = this.pedido.fornecedor.endereco;

        if (this.pedido.fornecedor.numero)
          auxEndereco += ', ' + this.pedido.fornecedor.numero; 

        if (this.pedido.fornecedor.complemento)
          auxEndereco += '/ ' + this.pedido.fornecedor.complemento;

        auxEndereco += ' - ' +
          this.pedido.fornecedor.bairro + ' - ' +
          this.pedido.fornecedor.cidade + ', ' +
          this.pedido.fornecedor.estado + ' - CEP: ' +
          this.pedido.fornecedor.cep

        return auxEndereco;
      },
      enderecoEntrega() {
        var endereco = this.pedido.compra.solicitacaoCompra.localEntrega.split("=|=");

        endereco = endereco[0] + ' - ' +
                    endereco[1] + ', ' +
                    endereco[2] + '/ ' +
                    endereco[3] + ' - ' +
                    endereco[4];

        return endereco;
      },
      contatoFornecedorPedido() {
        let auxContato = this.pedido.fornecedor.contato;

        if (this.pedido.fornecedor.telefone1)
          auxContato += ' - Tel.: ' + this.pedido.fornecedor.telefone1; 

        if (this.pedido.fornecedor.celular)
          auxContato += ' - Celular.: ' + this.pedido.fornecedor.celular;

        if (this.pedido.fornecedor.fax)
          auxContato += ' - Fax.: ' + this.pedido.fornecedor.fax;

        return auxContato;
      },
      formaPagamento() {
        let formaPagamento = '';

        if (this.pedido.idFormaPagamento > 0)
          formaPagamento += this.pedido.formaPagamento.descricaoFormaPagamento + ' - ';

        formaPagamento += this.pedido.formaPagamentoPedido;

        return formaPagamento;
      },
      totalPedidoCompra() {
        let valor = this.pedido.itensPedidoCompra.reduce((somatorio, item) => {
                      const quantidade = this.$options.filters.formatarNumero(item.quantidade, true);
                      const quantidadeCancelada = this.$options.filters.formatarNumero(item.quantidadeCancelada, true);
                      const valorUnitario = this.$options.filters.formatarNumero(item.valorUnitario, true);
                      const ipi = this.$options.filters.formatarNumero(item.ipiItemPedido, true);
                      const desconto = this.$options.filters.formatarNumero(item.descontoDinheiro, true);

                      let valor = ((quantidade  - quantidadeCancelada) * valorUnitario);

                      valor += (valor * ipi / 100);

                      valor -= desconto;
                      return somatorio + valor
                    }, 0);

        valor += this.pedido.valorFrete + this.pedido.valorICMSPedido - this.pedido.descontoPedido;

        return valor;
      },
      observacaoNFEndereco() {
        var endereco = ''

        if (this.configuracao.utilizarDadosFundacaoNF) {
          endereco = this.configuracao.enderecoFundacao + ' - ' +
            this.configuracao.bairroFundacao + ', ' +
            this.configuracao.cidadeFundacao + ' - ' +
            this.configuracao.estadoFundacao + ', ' +
            this.configuracao.cepFundacao; 
        } else {
          endereco = this.pedido.projeto.enderecoProjeto + ' - ' +
            this.pedido.projeto.bairroProjeto + ', ' +
            this.pedido.projeto.cidadeProjeto + ' - ' +
            this.pedido.projeto.ufProjeto + ', ' +
            this.pedido.projeto.cepProjeto;
        }

        return endereco;
      },
      documentosFundacao(){
        let documento = ''

        if (this.configuracao.utilizarDadosFundacaoNF) {
          documento = 'CNPJ: ' + this.configuracao.cnpjFundacao + ' - ' +
            'Insc. estadual: ' + this.configuracao.inscricaoEstadualFundacao + ' - ' +
            'Insc. municipal: ' + this.configuracao.inscricaoMunicipalFundacao;
        } else {
          documento = 'CNPJ: ' + this.pedido.projeto.cnpjProjeto + ' - ' +
            'Insc. estadual: ' + this.pedido.projeto.inscEstadualProjeto + ' - ' +
            'Insc. municipal: ' + this.pedido.projeto.inscMunicipalProjeto;
        }

        return documento; 
      },
      orgaoFinanciador() {
        projetoServico
        .orgaoFinanciador(this.pedido.idProjeto)
        .then(permissao => {
          if (permissao != null)
            this.numeroProcesso = this.pedido.projeto.nrProcesso + ' - ' + permissao
          else
            this.numeroProcesso = this.pedido.projeto.nrProcesso;
        })
      },
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Pedidos de Compra - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.botaoAcaoMostrar = true;
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;
      this.$root.botaoRetrocederRota = 'liberar-pedidos-compra';

      this.$events.on('botaoAcao', function () {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <modal-liberar-pedido :mostrar="modalLiberarPedido"
                            :id="pedidoSelecionado ? pedidoSelecionado.idPedidoCompra : ''"
                            :salvando="salvandoLiberacao"
                            @fechado="modalLiberarPedidoFechado"
                            @liberar="liberar">
      </modal-liberar-pedido>

      <modal-mensagem :mostrar="modalMensagem"
                      :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                      :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                      tipo="SolCompra"
                      @fechado="modalMensagensFechado">
      </modal-mensagem>

      <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                  :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoCompra : ''"
                                  tipo="compra"
                                  @fechado="modalArquivosFechado">
      </modal-arquivos-solicitacao>

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">

              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Pedidos de Compras - Relatório'"></cabecalho>

                <h3 class="m-t-none m-b">Pedido de Compra/ Ordem de Serviço Nº: {{ pedido.numeroPedidoCompra || '' }} | Sol. web: {{ pedido.compra ? pedido.compra.idSolicitacaoCompra : ''}}</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço entrega</dt>
                    <dd>{{ enderecoEntrega }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Fornecedor</dt>
                    <dd>{{ pedido.fornecedor ? pedido.fornecedor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>CNPJ</dt>
                    <dd>{{ pedido.fornecedor ? pedido.fornecedor.cpfCnpj : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Email fornecedor</dt>
                    <dd>{{ pedido.fornecedor ? pedido.fornecedor.emailCompras : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ enderecoPedido }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Contato fornecedor</dt>
                    <dd>{{ contatoFornecedorPedido }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-1">
                    <dt>Data do pedido</dt>
                    <dd>{{ pedido.dataPedido | formatarNumeroEmData }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Solicitante</dt>
                    <dd>{{ pedido.compra.solicitacaoCompra.pedidoPor ? pedido.compra.solicitacaoCompra.pedidoPor.nomePessoaFisicaJuridica : '---'  }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Nome contato</dt>
                    <dd>{{ pedido.compra.solicitacaoCompra ? pedido.compra.solicitacaoCompra.nomeSolicitante : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Email contato</dt>
                    <dd>{{ pedido.compra.solicitacaoCompra ? pedido.compra.solicitacaoCompra.emailSolicitante : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Telefone contato</dt>
                    <dd>{{ pedido.compra.solicitacaoCompra ? pedido.compra.solicitacaoCompra.telefoneSolicitante : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>Contrato</dt>
                    <dd> {{ pedido.contrato ? pedido.contrato.codigoInterno : ''  }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Num. processo</dt>
                    <dd>{{ pedido.numeroProcesso || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Ref. orçamento</dt>
                    <dd>{{ pedido.referenteOrcamento || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Condição pgto.</dt>
                    <dd> {{ formaPagamento }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Projeto</dt>
                    <dd>{{ pedido.projeto ? pedido.projeto.nomeProjeto : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Período projeto</dt>
                    <dd>{{ periodoProjeto }}</dd>
                  </dl>
                  <dl class="col-xs-2">
                    <dt>Período de vigência</dt>
                    <dd>{{ periodoDeVigencia }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Coordenador</dt>
                    <dd>{{ pedido.projeto.coordenador ? pedido.projeto.coordenador.nomePessoaFisicaJuridica : '---'}}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Unidade</dt>
                    <dd>{{ pedido.projeto.unidade ? pedido.projeto.unidade.nomeUnidade : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Departamento</dt>
                    <dd>{{ pedido.projeto.departamento ? pedido.projeto.departamento.nomeDepartamento : '---' }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="bs-callout bs-callout-info no-margin-top" v-for="(item, index) in pedido.itensPedidoCompra">

                  <lista-itens :item="item"
                               :index=index>
                  </lista-itens>

                </div>

                <div class="bs-callout bs-callout-primary">
                  <div class="row">
                    <dl class="col-xs-3">
                      <dt>Frete do pedido: R$ {{ pedido.valorFrete | formatarNumero }}</dt>
                    </dl>
                    <dl class="col-xs-3">
                      <dt>ICMS do pedido: R$ {{ pedido.valorICMSPedido | formatarNumero }}</dt>
                    </dl>
                    <dl class="col-xs-3">
                      <dt>Desconto do pedido: R$ {{ pedido.descontoPedido | formatarNumero }}</dt>
                    </dl>
                    <dl class="col-xs-3">
                      <dt>Total do pedido: R$ {{ totalPedidoCompra | formatarNumero }}</dt>
                    </dl>
                  </div>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="bs-callout bs-callout-primary">
                  <div class="row">
                    <dl class="col-xs-8">
                      <dt><h4>DADOS OBRIGATÓRIOS PARA EMISSÃO DA NOTA FISCAL</h4></dt>
                      <dd>Convênio/contrato: {{ numeroProcesso }} </dd>
                      <dd>{{ configuracao.utilizarDadosFundacaoNF ? pedido.projeto.nomeNotaFiscal : configuracao.nomeFundacao }}</dd>
                      <dd>{{ observacaoNFEndereco }}</dd>
                      <dd>{{ documentosFundacao }}</dd>
                    </dl>
                  </div>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Observação</dt>
                    <dd>{{ pedido.observacao || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Nota</dt>
                    <dd><span v-html="configuracao.observacaoCompras.replace(/\r\n/g, '<br>') || '---'" /></dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <div class="text-center">
                    <button type="button"
                            class="btn btn-success"
                            v-tooltip="'Enviar mensagem'"
                            @click="mostrarModalMensagem(pedido.compra.solicitacaoCompra)"
                            v-if="!configuracao.naoUtilizarMensageria">
                      <i class="fa fa-comment"></i> Mensagens
                    </button>

                    <button type="button"
                            class="btn btn-info"
                            v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                            @click="mostrarModalArquivos(pedido.compra.solicitacaoCompra)"
                            v-if="configuracao.usarArquivosSolicitacaoCompras">
                      <i class="fa fa-archive"></i> Arquivos
                    </button>

                    <button class="btn btn-primary"
                            v-tooltip="'Liberar pedido'"
                            @click="mostrarModalLiberarPedido(pedido)">
                      <i class="fa fa-check"></i> Liberar pedido
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/liberar-pedidos-compras/componentes/LiberarPedidosCompraRelatorio.vue